// ABOUTME: Clock/time icon component
// ABOUTME: Drawn in currentColor — `color` when given, else the notices' brown; in the dark theme the notice's text colour

import { cn } from "@shared/lib/utils"

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const ClockIcon = ({ className = "", size = 16, color }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("text-[#723B13] dark:text-inherit", className)}
    style={color ? { color } : undefined}
  >
    <path
      d="M8.00017 1.33325C6.68162 1.33325 5.39269 1.72425 4.29636 2.45679C3.20004 3.18933 2.34555 4.23052 1.84097 5.4487C1.33638 6.66687 1.20436 8.00731 1.4616 9.30052C1.71883 10.5937 2.35377 11.7816 3.28612 12.714C4.21847 13.6463 5.40636 14.2813 6.69956 14.5385C7.99277 14.7957 9.33322 14.6637 10.5514 14.1591C11.7696 13.6545 12.8108 12.8 13.5433 11.7037C14.2758 10.6074 14.6668 9.31846 14.6668 7.99992C14.6649 6.2324 13.9619 4.53784 12.7121 3.28802C11.4622 2.0382 9.76768 1.33519 8.00017 1.33325ZM10.6548 10.6546C10.5298 10.7796 10.3603 10.8498 10.1835 10.8498C10.0067 10.8498 9.83718 10.7796 9.71217 10.6546L7.5295 8.47192C7.4048 8.34638 7.33441 8.17687 7.3335 7.99992V5.33325C7.3335 5.15644 7.40374 4.98687 7.52876 4.86185C7.65379 4.73682 7.82336 4.66659 8.00017 4.66659C8.17698 4.66659 8.34655 4.73682 8.47157 4.86185C8.59659 4.98687 8.66683 5.15644 8.66683 5.33325V7.72392L10.6548 9.71192C10.7798 9.83694 10.85 10.0065 10.85 10.1833C10.85 10.36 10.7798 10.5296 10.6548 10.6546Z"
      fill="currentColor"
    />
  </svg>
)
